module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ONE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Tina couldn’t decide between ground glass and Drano.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She’d already sprinkled a pinch of smashed-up light-bulb—an easy-reading 40-watter—in Marvin’s Lucky Charms, when she started thinking maybe drain cleaner was the way to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One of the old Jews at the home, Mister Cornfeld, came down with the blood-squirts for a week and finally died after somebody put Liquid-Plumr in his prune juice. Old Jews were always drinking prune juice, always talking about what was going on in their pants. Either their constipation or their prostates or something skanky like that. At least her granddaddy, whatever his other faults, had not spent a whole lot of time boring her with what was happening downstairs. Till he bought the mall at ninety, Pop Lee snored like an idling diesel "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("and still liked to grab ass and talk nasty. When she found the trunk full of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moppets")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barely Legals")]), _vm._v(" after the funeral, she wasn’t exactly surprised. But at least the old skeek didn’t discuss his plumbing.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Tina could hear Marvin doing his prosperity chants from the bedroom and knew she had to make up her mind. Since he’d redirected his energy from day trading—which had cost them their condo—to developing and selling his new “Millionaire Mantra,” Marv had been experimenting with the perfect brand of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("satsang")]), _vm._v(" to put up on the Web. He was convinced there was an untapped pool of desperate New Agers who wanted to be rich and cosmic at the same time. His goal was to create the perfect quarter hour chant—ten minutes for Personal Prosperity, five for World Peace and Feeding the Children—then get himself up and streaming so folks could vocalize along with him, and send away for his line of videos, audio-cassettes, and the ever-popular BUDDHA WANTS YOU TO HAVE IT ALL! T-shirts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unfortunately, with each minute of spiritual honking, Tina’s determination to kill Marvin, sell his computers, and quit her job at Seventh Heaven was given renewed impetus. Mostly she just wanted to shut him up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hungh-uh, hungh-uh, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HUNGH-UH,")]), _vm._v("” came the turbulent sounds from their bedroom. “Hungh-uh, hungh-uh, hungh hungh "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HUNGH")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No doubt he was taping himself, too. Marv had the vid-cam on a tripod in front of the bed. Which was another thing….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Marvin wasn’t a petite man. In fact he was husky. Husky and soft, with a shaved head, no chest hair, and a little red moustache. Just the thought of him in there, cross-legged on a throw pillow, wearing the Gunga Din loincloth he thought made him look guruesque, was enough to set Tina crunching another pinch of glass and dipping into her bag for the industrial-strength Drano she’d pilfered from the rest home janitor’s closet.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("“Oh God, shut "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("up!")]), _vm._v("” Tina yelled to no one but herself. No way Marvin could hear over the din of his chants. By now he’d shifted to nose-hums, which really drove her off a cliff. It was hard to describe the sound he produced. The odd "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Om")]), _vm._v(" alternated with guttural blasts of ersatz Sanskrit and quick, bleated syllables like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sneep")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("snerm,")]), _vm._v(" the kind ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("of noise a goat might make if it tried to speak English and suffered from a cleft palate.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Marvin was always a big planner. After his Chant for Prosperity site was up and running, he told her, it was on to the next big plum: Eternal Life. If he could just cook up the right pitch, maybe mock up some phony interviews with people who looked 120 but healthy, he could charge aspiring eternal lifers fifty bucks a pop for tapes, books, and videocassettes explaining his discovery that certain sound vibrations could keep you young, possibly even ensure immortality.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You can’t prove they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t,")]), _vm._v("” he explained to Tina one morning, sitting at the kitchen table slathered in Indoor Sun, his artificial tan lotion, wearing the turban he’d fashioned from a floral dish towel. “As long as I’m still up on my hind legs, who’s to say I’m not the one guy on earth who’s gonna be here for the Trilennium, or whatever comes next?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was Marvin’s belief that Indian heritage, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("India")]), _vm._v(" Indian—curry, turban, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("memsahib")]), _vm._v("—made for an effective sales tool. But lately, for Tina’s money, he’d gone too far. These days he went straight from flossing his teeth in the morning to lounging around in turban and loincloth, inventing new and different chants and mantras. A necessary lifestyle, he’d tell her, if you wanted to turn yourself into the first big On-line Money Swami. Every day the cosmos blessed him with another sanctified cash concept.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Recalling all this made Tina wince. The idea of eternity spent listening to Marvin hum through his nose was so awful that she pulled out the Drano and poured a shot in his cereal before she remembered the envelope. Plenty of residents slid valuables of one kind or another under their mattresses, and the one perk of sheet-and-blanket duty was getting first crack at whatever treasures Seventh Heaven-ites saw fit to hide. Her first week on the job, she’d retrieved a sandwich bag stuffed with clipped-out cake recipes, an autographed photo of Frank Sinatra Junior, and sixteen crisp one-hundred-dollar bills wedged in a tattered paperback of Conrad Hilton’s autobiography, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Be My Guest.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What with Alzheimer’s, general forgetfulness, and the simple fact that people who moved into rest homes rarely moved out alive, mattress stashes made for a steady and occasionally fascinating second income.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Not wanting to miss a chance to poison her husband, but anxious to check out her booty, Tina hollered that breakfast was ready. She pulled the envelope out of her purse and ripped it open. Then she tapped the contents onto the kitchen table, stared at it, and screamed for a solid twenty seconds. It was that kind of day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t even hear Marvin when he stepped behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My God, you’re a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Delighted, he had flown in from the bedroom at the sound of his wife’s sudden demo of vocal skills. “Put a little more sinus in it and you’re right on target.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In jubilation—for his next "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("next")]), _vm._v(" project, Marv had his heart set on “His’n’ Her Love Chants,” so Tina’s outburst was pretty much an answered prayer—he snatched the bowl of Lucky Charms off the table with both hands, then leaned back and tipped the contents down his gullet in two enormous, chomping gulps.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Still crunchy,” he observed happily. “I hate when they sog up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Until he said it, Tina’d all but forgotten about the Drano and glass. It wasn’t the first time she’d spiked his food, just the first time she hadn’t scraped it into the trash at the last minute. Before this, it had been a tease, something she’d done to entertain herself. A little ant killer here, a dollop of furniture polish there. All in nuptial fun….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina was about to say something when Marv dropped on all fours and started frothing. What looked like dirty yogurt bubbled between his lips. It gushed out in a steady splurge, reminding her of the foam they sprayed on downed passenger planes. Tina’d never told anyone, but she always got weirdly excited by footage of houses with jets sticking out of them. Burning metal on lawns. The way the news cameras honed in on a single purse or tennis shoe. It did something to her. All those burly firemen with no faces wielding giant, spewing hoses….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When the foam-splats stopped, Marv grabbed a table leg and heaved himself to his knees. He began to claw at his throat, craning his head sideways like the RCA dog. His eyes met hers bulging with questions.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“I better shower,” Tina said, to the room at large, as she slid the item back in the envelope. It hit her, with the kind of wanton clarity the Almighty grants in moments of high emergency, that when the paramedics came, she wanted to look like she hadn’t even been in the ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("kitchen. Like she’d been showering and had padded out, dewy fresh, to find her husband dead from a toxic breakfast.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Howg gum?”")]), _vm._v(" Marv managed to sputter, a far cry from the disciplined mantras he’d perfected in the past few weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Accident.” Tina shrugged, feeling she owed him an explanation, however insincere.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Marv was beyond replying. The convulsions had knocked his turban off, and Tina could see his artificial tan line, a complete circle around his skull where his headgear started and the application of Indoor Sun had stopped. He was perfectly two-toned: toasty brown below and mottled pink above. The line cut just over his ears, lending his head a peculiar, makeshift quality, as if the top screwed off.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m going to miss you,” Tina said, and almost meant it. If she hadn’t bothered to pilfer Mrs. Zank’s mattress, things might have turned out differently. But it didn’t matter now. Marvin’s tongue had swelled up like a purple sock with a foot in it, and he seemed to be chewing. Blood leaked out of his mouth onto the linoleum.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was Marvin who’d selected—without consulting her—a cow-jumping-over-the-moon pattern for the kitchen floor. The cows had polka-dot pants on. And from the moment Marv worked the first self-adhesive tile out of the Home Depot box, she’d hated the sight of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So it was with a certain satisfaction that Tina realized a sea of clothed and smiling linoleum cows might well be the last sight her husband ever enjoyed on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Say good-bye to your friends,” she said.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507e3272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_ch01.vue
// module id = 75
// module chunks = 0